
import React from "react";
import { Editor } from "@tiptap/react";
import { Undo, Redo } from "lucide-react";
import MenuButton from "../MenuButton";

interface HistoryToolsProps {
  editor: Editor;
}

const HistoryTools = ({ editor }: HistoryToolsProps) => {
  return (
    <>
      <MenuButton 
        onClick={() => editor.chain().focus().undo().run()} 
        icon={<Undo className="h-4 w-4" />} 
        tooltip="Undo (Ctrl+Z)"
        disabled={!editor.can().undo()}
      />
      <MenuButton 
        onClick={() => editor.chain().focus().redo().run()} 
        icon={<Redo className="h-4 w-4" />} 
        tooltip="Redo (Ctrl+Shift+Z)"
        disabled={!editor.can().redo()}
      />
    </>
  );
};

export default HistoryTools;
